<template>
    <template v-if="filterType === 'text'">
        <InputText v-model="filterModel.value"
                   type="text"
                   name="filterInputText"
                   @keydown.enter="filterCallback()"
                   :pt="{
                    root: {
                        style: { 'width': '100%', 'height': '34px', 'font-size': '14px', 'color': 'black', ...filterStyle },
                        class: filterClass
                    },
                }" />
    </template>

    <template v-else-if="filterType === 'range'">
        <DatePicker v-model="filterModel.value"
                    selectionMode="range"
                    dateFormat="yy-mm-dd"
                    :manualInput="false"
                    @filter="filterCallback()"
                    :pt="{
                        input: {
                            style: { 'width': '100%', 'font-size': '14px', 'color': 'green', ...filterStyle },
                            class: filterClass
                        }
                    }" />
    </template>

    <template v-else-if="filterType === 'date'">
        <DatePicker v-model="filterModel.value"
                    selectionMode="single"
                    dateFormat="yy-mm-dd"
                    :manualInput="false"
                    @filter="filterCallback()"
                    :pt="{
                        input: {
                            style: { 'width': '100%', 'font-size': '14px', 'color': 'green', ...filterStyle },
                            class: filterClass
                        }
                    }" />
    </template>

    <template v-else-if="filterType === 'value'">
        <InputNumber v-model="filterModel.value"
                     :format="false"
                     @filter="filterCallback()"
                     :pt="{
                        root: {
                            style: { 'width': '100%', ...filterStyle },
                            class: filterClass
                        },
                    }" />
    </template>

    <template v-else-if="filterType === 'checkbox'">
        <Checkbox v-model="filterModel.value"
                  binary
                  @filter="filterCallback()"
                  :pt="{
                    root: {
                        style: { 'padding': '0', 'margin': '0', ...filterStyle },
                        class: filterClass
                    },
                    filterinput: {
                        style: {
                            'padding': '0', 'margin': '0'
                        },
                    },
                    input: {
                        style: {
                            'max-width': '25px',
                        },
                    }
                }" />
    </template>

    <template v-else-if="filterType === 'autocomplete'">
        <AutoComplete v-model="filterModel.value"
                      @filter="filterCallback()"
                      :suggestions="selectOptions"
                      @complete="searchItems"
                      :virtualScrollerOptions="{ itemSize: 38 }"
                      multiple
                      optionLabel="label"
                      dataKey="value"
                      dropdown
                      dropdownMode="current"
                      forceSelection
                      name="filterInputAutocomplete"
                      :delay="200"
                      :emptySelectionMessage="__('No data')"
                      :pt="{
                        emptyMessage: {
                            style: { 'padding-left': '15px', 'padding-top': '5px' }
                        },
                        root: {
                            style: { 'width': '100%' },
                            class: null
                        },
                        input: {
                            style: { 'width': '100%', ...filterInputStyle },
                            class: filterInputClass
                        },
                        token: {
                            style: { 'font-size': '14px', ...filterTokenStyle },
                            class: filterTokenClass

                        },
                        list: {
                            style: { 'width': '100%', 'overflow': 'auto', ...filterListStyle },
                            class: filterListClass
                        },
                        item: {
                            style: { 'padding': '3px 5px', 'margin': '0', 'height': 'auto', 'font-size': '14px', ...filterItemStyle },
                            class: filterItemClass
                        },
                        panel: {
                            style: { 'margin-top': '1px', 'padding-top': '0' },
                            //class: 'filter-autocomplete-panel'
                        },
                        container: {
                            style: { 'align-items': 'flex-start', ...filterStyle },
                            class: filterClass
                        },
                    }
                        " />
    </template>

    <template v-else-if="filterType === 'dropdown'">
        <Select v-model="filterModel.value"
                @filter="filterCallback()"
                :options="selectOptions"
                :virtualScrollerOptions="{ itemSize: 38 }"
                multiple
                optionLabel="label"
                optionValue="value"
                style="height:36px;width:100%;"
                name="filterInputSelect"
                :style="filterStyle"
                :class="filterClass"
                :emptySelectionMessage="__('No data')"
                :pt="{
                    emptyMessage: {
                        style: { 'padding-left': '15px', 'padding-top': '15px' },
                    },
                    input: {
                        style: { ...filterStyle, 'padding-top': '1px' },
                        class: filterClass
                    },
                    filterInput: {
                        style: filterInputStyle,
                        class: filterInputClass
                    },
                    list: {
                        style: filterListStyle,
                        class: filterListClass
                    },
                    item: {
                        style: { 'padding': '5px 5px', 'margin': '0', 'height': 'auto', 'font-size': '14px' },
                    },
                }
                    " />
    </template>

</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import DatePicker from 'primevue/datepicker';
import AutoComplete from 'primevue/autocomplete'
import Checkbox from 'primevue/checkbox'
import Select from 'primevue/select'
import { __ } from '@helper/utils.js'

const props = defineProps({
    filterModel: Object,
    filterCallback: Function,
    filterOptions: String,
    filterProps: Object,
    filterStyle: Object,
    filterClass: String,
    filterTokenStyle: Object,
    filterTokenClass: String,
    filterListStyle: Object,
    filterListClass: String,
    filterItemStyle: Object,
    filterItemClass: String,
    filterInputStyle: Object,
    filterInputClass: String,
    filterType: {
        type: String,
        default: 'text',
    }
})

const selectOptions = ref([{}])
const searchItems = async (event) => {
    await axios.post(route("helper-select", { select: [props.filterOptions], filter: event?.query, props: props.filterProps }))
        .then((response) => {
            selectOptions.value = response.data[props.filterOptions];
        });
}

onMounted(() => {
    if (props.filterType === 'dropdown') {
        searchItems({ query: '' })
    }
})

</script>

<style scoped>
.p-column-filter .p-column-filter-menu-button.p-link {
    margin-left: 2px !important;
    padding: 0 !important;
    margin: 0 !important;
    width: 20px;
    color: green !important;
}

.p-column-filter .p-column-filter-menu-button.p-column-filter-menu-button-active {
    margin-left: 2px !important;
    border-radius: 5px !important;
    background-color: firebrick;
    color: white !important;
}

.p-column-filter .p-column-filter-clear-button.p-link {
    padding: 0 !important;
    margin: 0 !important;
    width: 20px;
    color: #FEC107 !important;
}

.p-column-filter .p-column-filter-element .p-inputnumber .p-inputtext {
    font-size: 12px;
}

.p-virtualscroller {
    contain: content;
}

.p-autocomplete-items {
    position: relative;
}

.p-virtualscroller-content {
    position: relative;
}
</style>
